import axios from 'axios'
import airbrake from '@/helpers/airbrake'

const state = {
  nearbyGeos: null,
  loading: true,
  error: null
}

const getters = {
  nearbyGeos () {
    return state.nearbyGeos
  }
}

const mutations = {
  SET_NEARBY_GEOS (state, nearbyGeos) {
    state.nearbyGeos = nearbyGeos
  },
  LOADING (state) {
    state.loading = true
  },
  DONE (state) {
    state.loading = false
  },
  SET_ERROR (state, error) {
    state.error = error
  }
}

const actions = {
  loadGeoBrowser ({commit}, geoId) {
    commit('LOADING')
    return axios.get(`/geo_browser/${geoId}`)
      .then(response => {
        commit('SET_NEARBY_GEOS', response.data)
        commit('DONE')
      })
      .catch(error => {
        commit('SET_ERROR', error)
        commit('DONE')
        airbrake.notify(error)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./frontend/src/store/modules/geoBrowser/index.js